import React from 'react';
import {Autocomplete, AutocompleteProps, TextField} from "@mui/material";
import {useAutocompleteOptions} from "../../../../hooks/autocomplete/useAutocompleteOptions";
import {states} from "../../../../util/StateUtil";

const options = [
  {label: "All", id: ""},
  ...Array.from(states.keys()).sort().map(name => ({label: name, id: name}))
];

interface StateAutocompleteProps extends Omit<AutocompleteProps<any, any, any, any>, 'renderInput' | 'options'> {
}

const StateAutocomplete = (props: StateAutocompleteProps) => {

  const renderInput = (params: any) => (
    <TextField {...params} label={'State'} variant={'standard'} />
  )

  const {
    handleGetOptionLabel,
    handleIsOptionEqualToValue,
  } = useAutocompleteOptions({ autocompleteOptions: options })

  return (
    options?.length > 1 && <Autocomplete
      disablePortal
      disableClearable
      renderInput={renderInput}
      options={options}
      getOptionLabel={handleGetOptionLabel}
      isOptionEqualToValue={handleIsOptionEqualToValue}
      {...props}
    />
  )
}

export { StateAutocomplete };
